import React, {useState } from 'react';
import deshboard from '../../images/deshboard.png';
import analytics from '../../images/Analytics.png';
import ManageBooking from '../../images/ManageBooking.png';
import ManageEmployee from '../../images/ManageEmployee.png';

import Restaurant from '../../images/Restaurant.png';
import InventoryManagement from '../../images/InventoryManagement.png';
import Accounting from '../../images/Accounting.png';
import ChannelManager from '../../images/ChannelManager.png';


import { Link } from 'react-router-dom';
import Slider from "react-slick";

const testimonial = [
    {
        id: '01',
        Des: "Get real-time insights into occupancy, revenue, guest behavior, and operational performance. Make data-driven decisions with powerful dashboards designed for hotel owners and managers. Track trends, identify opportunities, and maximize profitability effortlessly.",
        Title: 'Analytics',
        Title1: 'Analytics',
        avatar: analytics,
    },
    {
        id: '02',
        Des: "Centralize all online and offline bookings in a single dashboard. Easily handle check-ins, check-outs, cancellations, and amendments with full visibility. Reduce overbooking and enhance the guest experience with a seamless booking process.",
        Title: 'Manage Booking',
        Title1: 'Manage Booking',
        avatar: ManageBooking,
    },
    {
        id: '03',
        Des: "Assign roles, track shifts, monitor attendance, and manage staff performance in one place. Streamline workforce operations and ensure smooth coordination across departments. Improve accountability and enhance service quality.",
        Title: 'Manage Employee',
         Title1: 'Manage Employee',
        avatar: ManageEmployee,
    },
    {
        id: '04',
        Des: "Digitize your restaurant operations with integrated Kitchen Order Ticket (KOT) management. Manage dine-in, room service, takeaway, and billing smoothly. Speed up order processing via QR code orders, reduce errors, and deliver a superior dining experience for guests.",
        Title: 'Restaurant',
        Title1: 'Restaurant',
        avatar: Restaurant,
    },
    {
        id: '05',
        Des: "Track stock levels across housekeeping, kitchen, bar, and maintenance with real-time accuracy. Get alerts for low stock, manage vendors, and optimize consumption. Prevent shortages and reduce wastage with smart inventory control.",
        Title: 'Inventory Management',
        Title1: 'Inventory Management',
        avatar: InventoryManagement,
    },
    {
        id: '06',
        Des: "Automate financial reporting with built-in accounting tailored for hotels. Manage invoices, expenses, taxes, and multi-department revenue with ease. Access transparent, error-free financial statements anytime.",
        Title: 'Accounting',
        Title1: 'Accounting',
        avatar: Accounting,
    },
    {
        id: '07',
        Des: "Connect your property to all major OTAs like Booking.com, MakeMyTrip, Agoda, and Airbnb: sync rates and availability in real time to avoid double bookings. Increase visibility and boost occupancy with a powerful multi-channel distribution system.",
        Title: 'Channel Manager',
        Title1: 'Channel Manager',
        avatar: ChannelManager,
    }
]

const ProjectSection = (props) => {
        const [activeFilter, setActiveFilter] = useState('analytics');

        const handleFilterClick = (filter) => {
            setActiveFilter(filter);
        }

        const settings = {
                dots: false,
                arrows: false,
                speed: 1000,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
                responsive: [
                    {
                        breakpoint: 1500,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            };
        
            const slider = React.useRef(null);


    return (
        <section className="portfolio_section xb-hidden section_space">
            <div className="container">
                <div className="heading_block">
                    <div className="row">
                        <div className="col-lg-12">
                            <h4 className="text-center">
                             Everything You Need to Manage Your Property — In One Place
                            </h4>
                            <p className="text-center">Whether you own a boutique hotel, luxury resort, or vacation rental, our software puts you in full control:</p>
                        </div>


                        <div className="col-lg-12 hide_desktop">
                            <div className="review_4col_carousel swiper">
                                <Slider ref={slider} {...settings}>
                                    {testimonial.map((testimonial, tsm) => (
                                        <div className="review_block_4" key={tsm}>
                                            <div className="review_admin">
                                                <div className="review_admin_image">
                                                    <img src={testimonial.avatar} alt="Maverick Phoenix" />
                                                </div>
                                                <div className="review_admin_info">
                                                    <button className='btn btn-project'>{testimonial.Title1}</button>
                                                    <h2>{testimonial.Title}</h2>
                                                    <p>{testimonial.Des}</p>
                                                    <Link to="/pricing"><b>Explore more</b></Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>

                        <div className='col-md-12 hide_mobile'>
                                <div className="filter_elements_nav">
                                    <ul className="unordered_list justify-content-center">
                                        <li className={activeFilter === 'analytics' ? 'active' : ''} onClick={() => handleFilterClick('analytics')}>Analytics</li>
                                        <li className={activeFilter === 'mBooking' ? 'active' : ''} onClick={() => handleFilterClick('mBooking')}>Manage Booking</li>
                                        <li className={activeFilter === 'mEmployee' ? 'active' : ''} onClick={() => handleFilterClick('mEmployee')}>Manage Employee</li>

                                        <li className={activeFilter === 'restaurant' ? 'active' : ''} onClick={() => handleFilterClick('restaurant')}>Restaurant</li>
                                        <li className={activeFilter === 'mInventory' ? 'active' : ''} onClick={() => handleFilterClick('mInventory')}>Inventory Management</li>
                
                                        <li className={activeFilter === 'accounting' ? 'active' : ''} onClick={() => handleFilterClick('accounting')}>Accounting</li>
                                        <li className={activeFilter === 'mChannel' ? 'active' : ''} onClick={() => handleFilterClick('mChannel')}>Channel Manager</li>
                                    </ul>
                                </div>
                                <div className={`filter_elements_wrapper row ${activeFilter === 'analytics' ? 'show_div' : 'hide_div'}`}>
                                    <div className='col-lg-4'>
                                        <div>
                                            <h2>Analytics</h2>
                                            <p>Get real-time insights into occupancy, revenue, guest behavior, and operational performance. Make data-driven decisions with powerful dashboards designed for hotel owners and managers. Track trends, identify opportunities, and maximize profitability effortlessly.</p>
                                            <Link to="/pricing"><b>Explore more</b></Link>
                                        </div>
                                    </div>
                                    <div className='col-lg-8'>
                                        <img src={analytics} alt="Mobile App Design"  style={{width:'100%'}}/>
                                    </div>
                                </div>
                                <div className={`filter_elements_wrapper row ${activeFilter === 'mBooking' ? 'show_div' : 'hide_div'}`}>
                                    <div className='col-lg-4'>
                                            <div>
                                                <h2>Manage Booking</h2>
                                                <p>Centralize all online and offline bookings in a single dashboard. Easily handle check-ins, check-outs, cancellations, and amendments with full visibility. Reduce overbooking and enhance the guest experience with a seamless booking process.</p>
                                                <Link to="/pricing"><b>Explore more</b></Link>
                                            </div>
                                        </div>
                                        <div className='col-lg-8'>
                                            <img src={ManageBooking} alt="Mobile App Design"  style={{width:'100%'}}/>
                                        </div>
                                </div>
                                <div className={`filter_elements_wrapper row ${activeFilter === 'mEmployee' ? 'show_div' : 'hide_div'}`}>
                                    <div className='col-lg-4'>
                                            <div>
                                                <h2>Manage Employee</h2>
                                                <p>Assign roles, track shifts, monitor attendance, and manage staff performance in one place. Streamline workforce operations and ensure smooth coordination across departments. Improve accountability and enhance service quality.</p>
                                                <Link to="/pricing"><b>Explore more</b></Link>
                                            </div>
                                        </div>
                                        <div className='col-lg-8'>
                                            <img src={ManageEmployee} alt="Mobile App Design"  style={{width:'100%'}}/>
                                        </div>
                                </div>
                                <div className={`filter_elements_wrapper row ${activeFilter === 'restaurant' ? 'show_div' : 'hide_div'}`}>
                                    <div className='col-lg-4'>
                                            <div>
                                                <h2>Restaurant</h2>
                                                <p>Digitize your restaurant operations with integrated Kitchen Order Ticket (KOT) management. Manage dine-in, room service, takeaway, and billing smoothly. Speed up order processing via QR code orders, reduce errors, and deliver a superior dining experience for guests.</p>
                                                <Link to="/pricing"><b>Explore more</b></Link>
                                            </div>
                                        </div>
                                        <div className='col-lg-8'>
                                            <img src={Restaurant} alt="Mobile App Design"  style={{width:'100%'}}/>
                                        </div>
                                </div>
                                <div className={`filter_elements_wrapper row ${activeFilter === 'mInventory' ? 'show_div' : 'hide_div'}`}>
                                    <div className='col-lg-4'>
                                            <div>
                                                <h2>Inventory Management</h2>
                                                <p>Track stock levels across housekeeping, kitchen, bar, and maintenance with real-time accuracy. Get alerts for low stock, manage vendors, and optimize consumption. Prevent shortages and reduce wastage with smart inventory control.</p>
                                                <Link to="/pricing"><b>Explore more</b></Link>
                                            </div>
                                        </div>
                                        <div className='col-lg-8'>
                                            <img src={InventoryManagement} alt="Mobile App Design"  style={{width:'100%'}}/>
                                        </div>
                                </div>
                                <div className={`filter_elements_wrapper row ${activeFilter === 'accounting' ? 'show_div' : 'hide_div'}`}>
                                    <div className='col-lg-4'>
                                            <div>
                                                <h2>Accounting</h2>
                                                <p>Automate financial reporting with built-in accounting tailored for hotels. Manage invoices, expenses, taxes, and multi-department revenue with ease. Access transparent, error-free financial statements anytime.</p>
                                                <Link to="/pricing"><b>Explore more</b></Link>
                                            </div>
                                        </div>
                                        <div className='col-lg-8'>
                                            <img src={Accounting} alt="Mobile App Design"  style={{width:'100%'}}/>
                                        </div>
                                </div>
                                <div className={`filter_elements_wrapper row ${activeFilter === 'mChannel' ? 'show_div' : 'hide_div'}`}>
                                    <div className='col-lg-4'>
                                            <div>
                                                <h2>Channel Manager</h2>
                                                <p>Connect your property to all major OTAs like Booking.com, MakeMyTrip, Agoda, and Airbnb: sync rates and availability in real time to avoid double bookings. Increase visibility and boost occupancy with a powerful multi-channel distribution system.</p>
                                                <Link to="/pricing"><b>Explore more</b></Link>
                                            </div>
                                        </div>
                                        <div className='col-lg-8'>
                                            <img src={ChannelManager} alt="Mobile App Design"  style={{width:'100%'}}/>
                                        </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </section>
    );
}

export default ProjectSection;